import { IS_BROWSER_IN_MOBILE, IS_OPEN_IN_MAC } from '@/common/constant/platform';

type HotkeyParam = {
  code: string; //  与keyboardevent的code保持一致
  keyText: string; // 显示用
  ctrlKey: boolean;
  altKey: boolean;
  shiftKey: boolean;
  metaKey: boolean;
};
enum PlatformType {
  Unsupport,
  Mac,
  Win,
}
class HotkeyDataHelper {
  private mapHotkey = new Map();
  constructor() {
    this.init();
  }
  public init() {
    this.mapHotkey.clear();
    const platformType = HotkeyDataHelper.GetPlatformType();
    const isOnMac = platformType === PlatformType.Mac;
    if (platformType === PlatformType.Unsupport) return;
    if (isOnMac) {
      this.createOrUpdateHotKey('rename', {
        code: 'KeyG',
        keyText: 'G',
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: true,
      });
      this.createOrUpdateHotKey('selectAll', {
        code: 'KeyA',
        keyText: 'A',
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: true,
      });
      this.createOrUpdateHotKey('addFavorite', {
        code: 'KeyB',
        keyText: 'B',
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: true,
      });
      this.createOrUpdateHotKey('delFavorite', {
        code: 'KeyB',
        keyText: 'B',
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: true,
      });
      this.createOrUpdateHotKey('search', {
        code: 'KeyP',
        keyText: 'P',
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: true,
      });
      this.createOrUpdateHotKey('delete', {
        code: 'Backspace',
        keyText: 'Del',
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: false,
      });
      this.createOrUpdateHotKey('copy', {
        code: 'KeyC',
        keyText: 'C',
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: true,
      });
      this.createOrUpdateHotKey('paste', {
        code: 'KeyV',
        keyText: 'V',
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: true,
      });
      this.createOrUpdateHotKey('move', {
        code: 'KeyX',
        keyText: 'X',
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: true,
      });
    } else {
      // isOnWin
      this.createOrUpdateHotKey('rename', {
        code: 'KeyG',
        keyText: 'G',
        ctrlKey: true,
        altKey: false,
        shiftKey: false,
        metaKey: false,
      });
      this.createOrUpdateHotKey('selectAll', {
        code: 'KeyA',
        keyText: 'A',
        ctrlKey: true,
        altKey: false,
        shiftKey: false,
        metaKey: false,
      });
      this.createOrUpdateHotKey('addFavorite', {
        code: 'KeyB',
        keyText: 'B',
        ctrlKey: true,
        altKey: false,
        shiftKey: false,
        metaKey: false,
      });
      this.createOrUpdateHotKey('delFavorite', {
        code: 'KeyB',
        keyText: 'B',
        ctrlKey: true,
        altKey: false,
        shiftKey: false,
        metaKey: false,
      });
      this.createOrUpdateHotKey('search', {
        code: 'KeyP',
        keyText: 'P',
        ctrlKey: true,
        altKey: false,
        shiftKey: false,
        metaKey: false,
      });
      this.createOrUpdateHotKey('delete', {
        code: 'Delete',
        keyText: 'Del',
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: false,
      });
      this.createOrUpdateHotKey('copy', {
        code: 'KeyC',
        keyText: 'C',
        ctrlKey: true,
        altKey: false,
        shiftKey: false,
        metaKey: false,
      });
      this.createOrUpdateHotKey('paste', {
        code: 'KeyV',
        keyText: 'V',
        ctrlKey: true,
        altKey: false,
        shiftKey: false,
        metaKey: false,
      });
      this.createOrUpdateHotKey('move', {
        code: 'KeyX',
        keyText: 'X',
        ctrlKey: true,
        altKey: false,
        shiftKey: false,
        metaKey: false,
      });
    }

    // 各个平台通用快捷键
    this.createOrUpdateHotKey('uploadFile', {
      code: 'KeyN',
      keyText: 'N',
      ctrlKey: false,
      altKey: false,
      shiftKey: true,
      metaKey: false,
    });
    this.createOrUpdateHotKey('uploadFolder', {
      code: 'KeyN',
      keyText: 'N',
      ctrlKey: false,
      altKey: true,
      shiftKey: true,
      metaKey: false,
    });
    this.createOrUpdateHotKey('download', {
      code: 'KeyD',
      keyText: 'D',
      ctrlKey: false,
      altKey: false,
      shiftKey: true,
      metaKey: false,
    });
    this.createOrUpdateHotKey('share', {
      code: 'KeyS',
      keyText: 'S',
      ctrlKey: false,
      altKey: false,
      shiftKey: true,
      metaKey: false,
    });
    this.createOrUpdateHotKey('open', {
      code: 'Enter',
      keyText: 'Enter',
      ctrlKey: false,
      altKey: false,
      shiftKey: false,
      metaKey: false,
    });
    this.createOrUpdateHotKey('help', {
      code: 'KeyH',
      keyText: 'H',
      ctrlKey: false,
      altKey: false,
      shiftKey: true,
      metaKey: false,
    });
    this.createOrUpdateHotKey('Escape', {
      code: 'Escape',
      keyText: 'Esc',
      ctrlKey: false,
      altKey: false,
      shiftKey: false,
      metaKey: false,
    });
    this.createOrUpdateHotKey('previous', {
      code: 'BracketLeft',
      keyText: '[',
      ctrlKey: false,
      altKey: false,
      shiftKey: false,
      metaKey: false,
    });
    this.createOrUpdateHotKey('next', {
      code: 'BracketRight',
      keyText: ']',
      ctrlKey: false,
      altKey: false,
      shiftKey: false,
      metaKey: false,
    });
  }
  public createOrUpdateHotKey(action: string, hotkey: HotkeyParam) {
    if (hotkey.code === '') {
      this.deleteHotkey(action);
      return;
    }
    this.mapHotkey.set(action, hotkey);
  }
  public deleteHotkey(action: string) {
    this.mapHotkey.delete(action);
  }
  public getHotkeyAction(hotkey: HotkeyParam | KeyboardEvent): string {
    for (const entry of this.mapHotkey.entries()) {
      if (
        entry[1].code === hotkey.code &&
        entry[1].ctrlKey === hotkey.ctrlKey &&
        entry[1].altKey === hotkey.altKey &&
        entry[1].shiftKey === hotkey.shiftKey &&
        entry[1].metaKey === hotkey.metaKey
      ) {
        return entry[0];
      }
    }
    return '';
  }

  // 获取动作对应的快捷键文案
  public getHotKeyTextArrayFromAction(action: string): string[] {
    if (!this.mapHotkey.has(action)) return [];
    return HotkeyDataHelper.HotkeyParamToTextArray(this.mapHotkey.get(action));
  }

  // 统一判断平台的逻辑，避免快捷键的表现和功能不一致
  private static GetPlatformType(): PlatformType {
    if (IS_BROWSER_IN_MOBILE) return PlatformType.Unsupport;
    if (IS_OPEN_IN_MAC) return PlatformType.Mac;
    return PlatformType.Win;
  }

  // 快捷键转文案
  private static HotkeyParamToTextArray(param: HotkeyParam): string[] {
    const textArray: string[] = [];
    const platformType = HotkeyDataHelper.GetPlatformType();
    if (platformType === PlatformType.Unsupport) return [];
    const isOnWin = platformType === PlatformType.Win;
    const isOnMac = platformType === PlatformType.Mac;
    if ((isOnWin || isOnMac) && param.ctrlKey) textArray.push('Ctrl');
    if (isOnWin && param.metaKey) textArray.push('Win');
    if (isOnMac && param.metaKey) textArray.push('⌘');
    if (isOnWin && param.altKey) textArray.push('Alt');
    if (isOnMac && param.altKey) textArray.push('⌥');
    if (isOnWin && param.shiftKey) textArray.push('Shift');
    if (isOnMac && param.shiftKey) textArray.push('⇧');
    textArray.push(param.keyText);
    return textArray;
  }
}
const hotkeyDataHelper = new HotkeyDataHelper();
export default hotkeyDataHelper;
export function GetDropdownItemShortCutText(itemValue: string) {
  const textArray = hotkeyDataHelper.getHotKeyTextArrayFromAction(itemValue);
  if (textArray.length === 0) {
    return '';
  }
  return textArray.join('+');
}
